module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_8011.51c759f6.png";